"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetVerificationOutput = exports.SamplingSchema = exports.SampleAllSamplingSchema = exports.CriteriaSamplingSchema = exports.CriteriaSamplingConfigSchema = exports.AssetConfigSchema = exports.FieldConfigSchema = void 0;
const zod_1 = require("zod");
exports.FieldConfigSchema = zod_1.z.object({
    receivableResponseTapeField: zod_1.z
        .string()
        .describe('Where in receivable response tape is this field?'),
    receivableDocumentionField: zod_1.z
        .string()
        .describe('Where in generated pdf answers is this field?'),
    comparisonFormula: zod_1.z
        .string()
        .describe('How should we compare. This formula can access baseFields/intermediateFields and documentation fields.'),
});
exports.AssetConfigSchema = zod_1.z.object({
    fields: zod_1.z.array(exports.FieldConfigSchema).describe('Fields to verify'),
});
exports.CriteriaSamplingConfigSchema = zod_1.z.object({
    name: zod_1.z.string().describe('Unique name for the criteria'),
    formula: zod_1.z.string().describe('Formula that resolves to boolean'),
    percentageRate: zod_1.z.number().optional().describe('Defaults to 1 if undefined'),
    maximum: zod_1.z
        .number()
        .optional()
        .describe('Maximum amount to sample, if undefined, no max is enforced'),
});
exports.CriteriaSamplingSchema = zod_1.z.object({
    type: zod_1.z.literal('criteria'),
    config: zod_1.z.object({
        criterion: zod_1.z
            .array(exports.CriteriaSamplingConfigSchema)
            .describe('Each criteria is independent, allows for multiple "buckets"'),
    }),
});
exports.SampleAllSamplingSchema = zod_1.z.object({
    type: zod_1.z.literal('sampleAll'),
    name: zod_1.z.string(),
});
exports.SamplingSchema = zod_1.z.discriminatedUnion('type', [
    exports.CriteriaSamplingSchema,
    exports.SampleAllSamplingSchema,
]);
var AssetVerificationOutput;
(function (AssetVerificationOutput) {
    AssetVerificationOutput.VerificationStatusValues = [
        'Untested', // no document was uploaded
        'TextractFailed', // document failed to textract or sanitize
        'UnverifiedFailure', // textract succeeded but verification failed for 1 or more fields (no manual edit yet.)
        'VerifiedFailure', // verification failures confirmed by manual edits.
        'Passed', // verification passed
    ];
    AssetVerificationOutput.ReportEntryStatusIterable = [
        'passed',
        'failed',
        'finley_review', // status subtype of failure (UnverifiedFailure)
        'missing_raw_documentation',
        'missing_generated_documentation',
    ];
    AssetVerificationOutput.CURRENT_STORED_VERIFICATION_RESULT_SCHEMA_VERSION = 1;
})(AssetVerificationOutput || (exports.AssetVerificationOutput = AssetVerificationOutput = {}));
//# sourceMappingURL=AssetVerification.js.map